import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { useLocation, Link } from 'react-router-dom'
import { Button, Container, Row, Col } from 'reactstrap'

import SmileIcon from '../../../assets/img/icons/SMILE.svg'
import Icon from '../../../components/Icons/Icon'
import { getUserFullname } from '../../../services/authenticationChecker'
import { resetCart } from '../../../redux/payment/actions'

import './PaymentResult.css'

const PaymentResult = () => {
    const location = useLocation()
    const [receiptNumber, setReceiptNumber] = useState(null)
    const dispatch = useDispatch()

    useEffect(() => {
        const params = new URLSearchParams(location.search)
        setReceiptNumber(params.get('id'))
    }, [location])

    const isSuccessful = () => receiptNumber && receiptNumber > 0

    const onResetCart = () => {
        if (isSuccessful()) dispatch(resetCart())
    }

    return (
        <Container className="payment-result">
            <Row>
                {isSuccessful() ? (
                    <Col>
                        <h3 className="text-center mt-3">
                            <Icon src={SmileIcon} size="xlg" />
                            سفارش موفق
                        </h3>
                    </Col>
                ) : (
                    <Col>
                        <h3 className="text-center mt-3">
                            <Icon src={SmileIcon} size="xlg" />
                            سفارش ناموفق
                        </h3>
                    </Col>
                )}
            </Row>
            <Row className="border-bottom border-top">
                <Col md={3}></Col>
                <Col md={6} className="mt-3">
                    <p>{getUserFullname()} عزیز</p>

                    <br />
                    {isSuccessful() ? (
                        <>
                            <p className="mb-0">از شما سپاسگذاریم.</p>
                            <p>
                                سفارش شما با موفقیت ثبت شد. به زودی با شما تماس
                                گرفته خواهد شد.
                            </p>
                        </>
                    ) : (
                        <p>
                            متاسفانه سفارش با مشکل مواجه شد، لطفا دوباره تلاش
                            کنید
                        </p>
                    )}
                    <br />

                    <div className="d-flex justify-content-space payment-result__receipt-wrapper">
                        <p>شماره پیگیری سفارش</p>
                        <p>{receiptNumber}</p>
                    </div>
                </Col>
            </Row>
            <Row>
                <Col md={2}></Col>
                <Col md={8} className="mt-3">
                    <Link to="/" onClick={onResetCart}>
                        <Button className="payment-result__action-btn">
                            باشه
                        </Button>
                    </Link>
                </Col>
            </Row>
        </Container>
    )
}

export default PaymentResult
